const metaEnv = import.meta.env ?? {};

const trimTrailingSlash = (value: string): string => value.replace(/\/$/, '');

const apiTarget = trimTrailingSlash(
  metaEnv.VITE_API_BASE_URL || process.env.VITE_API_BASE_URL || 'https://btc-panel.bitpulse.me',
);

const appBaseUrl = trimTrailingSlash(
  metaEnv.VITE_APP_BASE_URL || process.env.VITE_APP_BASE_URL || 'https://my.paygatex.io',
);

const landingBaseUrl = trimTrailingSlash(
  metaEnv.VITE_LANDING_BASE_URL || process.env.VITE_LANDING_BASE_URL || 'https://paygatex.io',
);

interface EnvConfig {
  /** Request base URL. In dev — empty string (same-origin via Vite proxy). */
  API_BASE_URL: string;
  /** Upstream API used by Vite dev proxy (from VITE_API_BASE_URL). */
  API_PROXY_TARGET: string;
  /** Public LK origin for invoice links, return URLs, analytics. */
  APP_BASE_URL: string;
  /** Marketing site origin (auth logo link, referrals). */
  LANDING_BASE_URL: string;
  NODE_ENV: 'development' | 'production' | 'test';
}

function validateEnv(): EnvConfig {
  return {
    API_BASE_URL: metaEnv.DEV ? '' : apiTarget,
    API_PROXY_TARGET: apiTarget,
    APP_BASE_URL: appBaseUrl,
    LANDING_BASE_URL: landingBaseUrl,
    NODE_ENV: (metaEnv.MODE as EnvConfig['NODE_ENV']) || 'development',
  };
}

export const env = validateEnv();

/** Builds absolute public URL on the LK origin (e.g. `/invoice/{id}`). */
export const buildPublicUrl = (path = '/'): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${env.APP_BASE_URL}${normalizedPath}`;
};
